export interface GasPriceRow {
  key: string; stationId: string; station: string; name: string; address: string; fuel: string;
  province: string; rawPrice: string; comparable: boolean;
  price: number | null; ours: boolean; collectedAt: string; reportedAgo: string;
  latitude: number | null; longitude: number | null;
  stationLatitude: number | null; stationLongitude: number | null;
}
export interface GasPricesSnapshot {
  rows: GasPriceRow[]; fetchedAt: string; stale: boolean; warning?: string;
}
export function hasCoordinates(row: { latitude: number | null; longitude: number | null }): boolean {
  return row.latitude !== null && row.longitude !== null && Math.abs(row.latitude) <= 90 && Math.abs(row.longitude) <= 180
    && !(row.latitude === 0 && row.longitude === 0);
}
// Is Ours is the model's brand flag, not proof this is the selected station itself.
export function competitorSummary(rows: GasPriceRow[]) {
  const competitors = rows.filter((row) => !row.ours && row.comparable);
  const prices = competitors.flatMap((row) => row.price === null ? [] : [row.price]);
  return {
    count: competitors.length, priced: prices.length,
    average: prices.length ? prices.reduce((sum, value) => sum + value, 0) / prices.length : null,
    lowest: prices.length ? Math.min(...prices) : null,
    highest: prices.length ? Math.max(...prices) : null
  };
}
export const formatPrice = (value: number | null) => value === null ? "—" : `$${value.toFixed(3)}`;
export const locationPrice = (row: GasPriceRow) => row.comparable ? formatPrice(row.price) : row.price === null ? "—" : `${row.rawPrice || row.price}*`;
